import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Create new Classgroup", -1)
const _hoisted_4 = { class: "position-absolute top-0 end-0 mt-2 me-3 pt-2 pe-1 z-index-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_6 = { class: "card-body bg-light" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["selected", "textContent"]
const _hoisted_11 = ["value", "selected", "textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "students-emails" }, "Invite Students (Optional)")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row ps-3 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "row aling-middle align-items-center fs--1" }, "You can also do this later. When you’re familiar with Latudio, you may want to do it right away.")
], -1)
const _hoisted_17 = ["textContent"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = ["textContent", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_smart_tagz = _resolveComponent("smart-tagz")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "btn btn-falcon-default btn-sm",
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          title: "",
          "data-bs-original-title": "Back to Group",
          to: {
            name: 'Home',
          }
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Form, {
        id: "classgroup-create-form",
        onSubmit: _ctx.processForm,
        "validation-schema": _ctx.schema,
        onKeypress: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
      }, {
        default: _withCtx(({ isSubmitting, errors }) => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Input, {
              id: "classgroup-create-group-name",
              label: "Group Name*",
              name: "name",
              placeholder: "Group Name",
              error: errors.name
            }, null, 8, ["error"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", {
              for: "classgroup-create-language",
              textContent: _toDisplayString('Language Pair*')
            }, null, 8, _hoisted_9),
            _createVNode(_component_Field, {
              id: "classgroup-create-language",
              name: "language",
              class: "form-select",
              as: "select",
              value: 0,
              "aria-label": "Select Language Pair"
            }, {
              default: _withCtx(({ value }) => [
                _createElementVNode("option", {
                  value: 0,
                  disabled: "",
                  selected: value,
                  textContent: _toDisplayString('Select Language Pair...')
                }, null, 8, _hoisted_10),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: language.id,
                    selected: language.id,
                    key: idx,
                    textContent: _toDisplayString(language.description)
                  }, null, 8, _hoisted_11))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", {
              class: "text-danger text-sm",
              textContent: _toDisplayString(errors.language)
            }, null, 8, _hoisted_12)
          ]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Field, {
              id: "classgroup-invite-students",
              name: "students",
              "aria-label": "Enter students emails",
              modelValue: _ctx.students,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.students) = $event))
            }, {
              default: _withCtx(() => [
                _hoisted_15,
                _hoisted_16,
                _createVNode(_component_smart_tagz, {
                  id: "students-emails",
                  "input-placeholder": "Enter students emails",
                  editable: false,
                  "allow-duplicates": false,
                  allowPaste: { delimiter: /[\s,]+/ },
                  theme: {
                background: '#fff',
              },
                  "on-changed": _ctx.addStudents,
                  onKeypress: _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                }, null, 8, ["on-changed"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors, (error, key, idx) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                (key.includes('students') && idx == 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "text-danger text-sm",
                      textContent: _toDisplayString('Ingressed emails must be valid')
                    }, null, 8, _hoisted_17))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              class: "btn btn-primary d-block w-100 mt-3",
              type: "submit",
              name: "submit",
              textContent: _toDisplayString('Create'),
              disabled: isSubmitting
            }, null, 8, _hoisted_20)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}